import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { TableModule } from 'primeng/table';
import { CardModule } from 'primeng/card';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { InputSwitchModule } from 'primeng/inputswitch';
import { DropdownModule } from 'primeng/dropdown';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { PanelModule } from 'primeng/panel';
import { CheckboxModule } from 'primeng/checkbox';

import { TabViewModule } from 'primeng/tabview';
import { CalendarModule } from 'primeng/calendar';
import { InputNumberModule } from 'primeng/inputnumber';
import { TagModule } from 'primeng/tag';
import { InputTextarea } from 'primeng/inputtextarea';
import { DialogModule } from 'primeng/dialog';
import { EditorModule } from 'primeng/editor';
import { InputMaskModule } from 'primeng/inputmask';
import { CasesStatesListComponent } from './cases-states-list/cases-states-list.component';
import { CasesStatesDetailComponent } from './cases-states-detail/cases-states-detail.component';
import { CasesStatesRoutingModule } from './cases-states-routing.module';
import { ColorPickerModule } from 'primeng/colorpicker';
import { MessagesModule } from 'primeng/messages';
import { MessageModule } from 'primeng/message';


import { CoreModule } from 'src/app/core/core.module';
@NgModule({ declarations: [
        CasesStatesListComponent,
        CasesStatesDetailComponent
    ], imports: [CoreModule,
        CasesStatesRoutingModule,
        BrowserModule,
        FormsModule,
        ReactiveFormsModule,
        TableModule,
        CardModule,
        ButtonModule,
        InputTextModule,
        InputNumberModule,
        InputMaskModule,
        InputSwitchModule,
        DropdownModule,
        ConfirmDialogModule,
        PanelModule,
        CheckboxModule,
        TabViewModule,
        CalendarModule,
        TagModule,
        InputTextarea,
        DropdownModule,
        DialogModule,
        EditorModule,
        ColorPickerModule,
        MessageModule,
        MessagesModule], providers: [provideHttpClient(withInterceptorsFromDi())] })
export class CasesStatesModule { }
